import { type CoreIconName, CoreIconNames } from '../remix/core.ts'
import { type SvgIconName, SvgIconNames } from '../svg/types/names.ts'

export type IconName = SvgIconName | CoreIconName
export const IconNames = [...SvgIconNames, ...CoreIconNames]

export const isIconName = (name: unknown): name is IconName => {
  return IconNames.includes(name as IconName)
}
